import datapoints from './datapoints';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyShowOptOutDialog } from 'owa-mail-opt-out-view';
import { optIntoJsmvvmClientAndRedirect } from 'owa-optin/lib/utils/owaOptinUtility';
import { setClientOptedIn } from 'owa-mail-store-actions';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export default createLegacyActionWithDatapoint('clientOptOut', datapoints.optOut)(
    function clientOptOut(modulePath?: string) {
        setClientOptedIn(false);

        if (isFeatureEnabled('usv-forum')) {
            lazyShowOptOutDialog.importAndExecute(modulePath);
        } else {
            optIntoJsmvvmClientAndRedirect(modulePath);
        }
    }
);
